import React, { Component } from 'react';

import Item from './styles';
import { Button } from '../styles';

import avatar from '../../../../../assets/images/default-avatar-user.png';

class ListItem extends Component {
  editItem = () => {
    this.props.edit(this.props.item);
  };

  editButton = () => {
    const { id: roleId, role: roleType } = this.props.item;
    const { userId, roleType: userType } = this.props.user;

    if (roleId === userId) return null;
    if (userType === 'manager' && roleType !== 'Funcionário') return null;

    return (
      <Button type="submit" onClick={this.editItem}>
        <span>
          {'Editar'}
        </span>
      </Button>
    );
  }

  render() {
    const { name, role } = this.props.item;

    return (
      <Item>
        <img src={avatar} alt="Avatar" />
        <div style={{ flex: 1 }}>
          <h3>{name}</h3>
          <p>{role}</p>
        </div>
        {this.editButton()}
      </Item>
    );
  }
}

export default ListItem;
